import React from 'react';

export default function ContentGapsVisualization({ data }) {
  if (!data) {
    return <div className="content-gaps"><p>No data available</p></div>;
  }

  // Handle both array and object formats
  const gaps = data?.contentGaps?.missingSubtopics || [];
  const questions = data?.contentGaps?.unansweredQuestions || [];

  return (
    <div className="content-gaps">
      <h3>🔍 Content Gaps & Opportunities</h3>
      
      <div className="gaps-section">
        <h4>📌 Missing Subtopics</h4>
        {Array.isArray(gaps) && gaps.length > 0 ? (
          <div className="gaps-list">
            {gaps.map((gap, idx) => (
              <div key={idx} className="gap-item">
                <span className="gap-topic">{gap.topic}</span>
                <p className="gap-desc">{gap.description}</p>
                <span className="gap-opportunity">🎯 {gap.opportunity}</span>
              </div>
            ))}
          </div>
        ) : (
          <p>No gaps identified</p>
        )}
      </div>

      <div className="gaps-section">
        <h4>❓ Unanswered Questions</h4>
        {Array.isArray(questions) && questions.length > 0 ? (
          <div className="questions-list">
            {questions.map((q, idx) => (
              <div key={idx} className="question-item">
                <span className="question-text">{q.question}</span>
                <span className="question-freq">Frequency: {q.frequency}</span>
              </div>
            ))}
          </div>
        ) : (
          <p>No questions identified</p>
        )}
      </div>
    </div>
  );
}
